import { createStore } from "vuex";

let store = createStore({
  state: {
    userInfo: {
      truename: "",
      username: "", //"a976ca5519fcb81f",
      token: "", //"b50a6ac9f5e516903b27e1ec62cf5873",
    },
    partnerId: "", // 合作商id
    partnerConfig: {}, // 合作商的配置信息
    appkey: "",
    channel: "",
    secret: "",
    titleStatus: false, // 自定义页面标题状态
  },
  getters: {
    /**
     * @description: 判断是否已登录
     * @param {*} state
     * @return {*}
     */
    isLogin(state) {
      return !!state.userInfo.username;
    },
    /**
     * @description: 返回用户信息
     * @param {*} state
     * @return {*}
     */
    userInfo(state) {
      return state.userInfo;
    },
  },
  mutations: {
    /**
     * @description: 存储用户信息
     * @param {*} state
     * @param {*} data 设置用户信息的值
     * @return {*}
     */
    setUserInfo(state, data) {
      state.userInfo = data;
    },
    /**
     * @description: 存储合作商的配置信息
     * @param {*} state
     * @param {*} data 配置信息
     * @param {*} option
     * @return {*}
     */
    setPartnerConfig(state, data) {
      state.partnerConfig[data.option] = data.data;
    },
    /**
     * @description: 存储合作商的配置信息
     * @param {*} state
     * @param {*} data 配置信息
     * @param {*} option
     * @return {*}
     */
    setAll(state, data) {
      state.userInfo = data.userInfo;
      state.partnerId = data.partnerId;
      state.partnerConfig = data.partnerConfig;
      state.appkey = data.appkey;
      state.channel = data.channel;
      state.secret = data.secret;
      state.titleStatus = data.titleStatus;
    },
  },
  actions: {},
  modules: {},
});

export default store;

export function myStore() {
  return store;
}
